import { User, VenueListUserFvouritesFilter } from '../../graphql/API';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

const venueListUserFvourites = /* GraphQL */ `
  query VenueListUserFvourites($filter: VenueListUserFvouritesFilter!) {
    venueListUserFvourites(filter: $filter) {
      items {
        id
        email
        firstname
        lastname
        agency
        agencyProfileUrl
        birthdate
        picture {
          large
          medium
          small
          thumbnail
        }
        instagramHandle
        instagramFollowers
        marketID
        marketName
        createdAt
        updatedAt
        approvalDate
        status
        lastSeen
        totalCheckins
        totalCheckinLastMonth
        totalOfferValueRedeemed
        instagramVerificationRequested
        instagramDuplicates
        birthdateDuplicates
        tags
        totalPortfolioContents
        city
        noshowCredits
        premium
        points
        instagramVerified
        inviteCredits
        lifestyle
      }
    }
  }
`;

export const venueListUserFavouritesApi = async (filter: VenueListUserFvouritesFilter): Promise<User[]> => {
  const result = await executeGql<User[]>(venueListUserFvourites, { filter });
  return processGqlResult<User[]>('venueListUserFvourites.items', result);
};
